import React from "react";
import "./Footer.css";
import { useRef } from 'react';


const Footer: React.FC = () => {
  const footerBg = process.env.PUBLIC_URL + "/images/Footer.webp";

  return (
    <footer className="footer" style={{ backgroundImage: `url(${footerBg})` }}>
      <div className="footer-overlay">
        <div className="footer-container">
          {/* Left Column */}
          <div className="footer-left">
            <h2 className="footer-logo">
              NEXT<span>UDIO</span>
            </h2>
            <p className="footer-description">
              The company principle of Architecture-Studio is the collective conception.
              From the very beginning, the practice has believed in the virtues of exchange,
              crossing ideas, common effort, shared knowledge and enthusiasm.
            </p>
          </div>

          {/* Right Column */}
          <div className="footer-right">
  <h4 className="footer-heading">GET IN TOUCH</h4>

  <p>
    <i className="fas fa-phone-alt"></i> : +961 3 453 306 | +961 71 077 605
  </p>
  <p>
    <i className="fab fa-whatsapp"></i> : +961 71 077 605
  </p>
  <p>
    <i className="fas fa-envelope"></i> : info@nextudio.co
  </p>

            <div className="footer-icons">
  <a
    href="https://www.facebook.com/share/1ZsvmkC3Xc/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-facebook-f" />
  </a>
  <a
    href="https://www.instagram.com/nextudio.co?igsh=MTVkbDIwN3kxazRkbA=="
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-instagram" />
  </a>
  <a
    href="https://www.linkedin.com/company/nextudio-architects/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-linkedin-in" />
  </a>
  <a
    href="https://www.behance.net/nextudiobeirut"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-behance" />
  </a>
</div>

          </div>
        </div>

        <hr />
        <p className="footer-bottom">
          NEXTUDIO architects (C) {new Date().getFullYear()} ALL RIGHTS RESERVED
        </p>
      </div>
    </footer>
  );
};

export default Footer;
